import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Footer.css';

const Footer = () => {
  return (
    <footer id="footer" className="footer">
      <div className="footer__container">
        <div className="footer__content">
          <div className="footer__section">
            <h4>Product</h4>
            <ul>
              <li><Link to="/gridx">GRIDx</Link></li>
              <li><a href="#features">Features</a></li>
            </ul>
          </div>

          <div className="footer__section">
            <h4>Company</h4>
            <ul>
              <li><Link to="/team">Team</Link></li>
              <li><Link to="/mission">Mission</Link></li>
              <li><Link to="/careers">Careers</Link></li>
            </ul>
          </div>

          <div className="footer__section">
            <h4>Contact</h4>
            <ul>
              <li><Link to="/contact">Get in Touch</Link></li>
              <li><a href="mailto:info@pulsarelectronic.com">Email</a></li>
            </ul>
          </div>
        </div>

        <div className="footer__bottom">
          <p className="footer__copyright">
            &copy; 2025 Pulsar Electronic Solution. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
